import React, {useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Form, Label, CardImg } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import "../PublicPromoCode/datatables.scss"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import _ from 'lodash'
import Select from "react-select"
import Dropzone from "react-dropzone"
import {Link} from 'react-router-dom'
import moment from "moment"
import SweetAlert from "react-bootstrap-sweetalert"
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const EditCarouselBanner = (props) => {
  const sections = [
    {value: "home", label: "Home", path: "frx-home"},
    {value: "payments", label: "Payments", path: "#"},
    {value: "rewards", label: "Rewards", path: "rewards"},
    {value: "makan_master", label: "Makan Master", path: "makan-master"},
    {value: "amperkz_transition", label: "AMPerkz Transition", path: "#"},
    {value: "estore", label: "EStore", path: "estore"},
  ]
  const [token, setToken] = useState()
  const [selectedSection, setselectedSection] = useState(sections[0])
    const [selectedPosition, setselectedPosition] = useState({label: props?.location?.state?.sort_order, value: props?.location?.state?.sort_order})
    const [selectedStatus, setselectedStatus] = useState()
    const [selectedFiles, setselectedFiles] = useState([])
    const [neverEnding, setNeverEnding] = useState(false)
    const [imageURL, setImageUrl] = useState()
    const [navigateObj, setNavigateObj] = useState()
    const [success_msg, setsuccess_msg] = useState(false)
    const [errorMessage, SetErrorMessage] = useState('')
    const [errorMsgAlert, setErrorMsgAlert] = useState(false)
    useEffect(() => {
      const token = localStorage.getItem("AuthenticationToken")
      setToken(token)
      sections.map((item)=>{
        if(item.value == props?.location?.state?.page){
          setselectedSection(item)
        }
      })
      if(props?.location?.state?.navigate_to.includes("{")){
         const navigateTo = JSON.parse(props?.location?.state?.navigate_to)
         setNavigateObj(navigateTo)
      }else{
        setNavigateObj(props?.location?.state?.navigate_to)
      }
      setImageUrl(props?.location?.state?.image_url ? props?.location?.state?.image_url : "")
      return () => {
        
      }
    }, [props.location.state])
    const sortOptions = [
      {value: 1, label: 1},
      {value: 2, label: 2},
      {value: 3, label: 3},
      {value: 4, label: 4},
      {value: 5, label: 5},
      {value: 6, label: 6},
      {value: 7, label: 7},
      {value: 8, label: 8},
      {value: 9, label: 9},
      {value: 10, label: 10}
    ]
    const statusOptions = [
      {value: "Y", label: "Enable"},
      {value: "N", label: "Disable"}
    ]

    const renderSuccessAlert = () => {
      return (
        <SweetAlert
          title="Success!"
          success
          confirmBtnBsStyle="success" 
          onConfirm={() => {
            setsuccess_msg(false)       
            props.props?.history.push("/campaigns")
          }}
          onCancel={() => {
            setsuccess_msg(false)
          }}
        >
          {"Carousel Banner Added."}
        </SweetAlert>
      )
    }
    const renderFailureAlert = () => {
      return (
        <SweetAlert
          title="Warning!"
          warning        
          confirmBtnBsStyle="warning"
          onConfirm={() => {
            setErrorMsgAlert(false)
          }}
        >
          {errorMessage ? errorMessage : "Error. Something went wrong."}
        </SweetAlert>
      )
    }
  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  function handleSubmit(){
    const page = selectedSection?.value;
    const position = selectedPosition ? selectedPosition.value : ""
    const nav_to = document.getElementById("navigate_input").value;
    const publishAt = document.getElementById("publishAt_input").value!== '' && moment(document.getElementById("publishAt_input").value).format("YYYY/MM/DD HH:mm");
    const unpublishAt = document.getElementById("unpublishAt_input").value !=='' && moment(document.getElementById("unpublishAt_input").value).format("YYYY/MM/DD HH:mm");
    const createdDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    const version = document.getElementById("version_input").value;
    const status = selectedStatus ? selectedStatus.value : statusOptions[0].value

    var myHeaders = new Headers();
    
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    
    var formdata = new FormData();
    formdata.append("path", "carousel/update");
    formdata.append("env", "staging");
    formdata.append("created_datetime", props?.location?.state?.created_datetime);
    if(selectedFiles?.length > 0){
      formdata.append('userfile', selectedFiles[0], selectedFiles[0]?.path);
    }
    formdata.append("item_id", `${props?.location?.state?.item_id}`);
    formdata.append("item_status", status ? status : props?.location?.state?.item_status);
    formdata.append("item_type", "\"carousel_banner\"");
    formdata.append("item_version", version ? version : props?.location?.state?.item_version);
    formdata.append("navigate_to", nav_to ? nav_to : props?.location?.state?.navigate_to);
    formdata.append("page", page ? page : props?.location?.state?.page);
    formdata.append("published_at", publishAt !== false ? publishAt : props?.location?.state?.published_at);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt !== '' ? unpublishAt : props?.location?.state?.unpublished_at);
    formdata.append("slider_delay", "3");
    formdata.append("sort_order", position ? position : props?.location?.state?.sort_order);
    formdata.append("api", "true");
    formdata.append("updated_datetime", createdDate);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if(response.status == 200){
          setsuccess_msg(true)
        }else{
          SetErrorMessage("Unable to Add Carousel Banner")
          setErrorMsgAlert(true)
        }
        response.json()
      })
      .then(result => {})
      .catch(error => console.log('error', error));
    
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Carousel Banners" breadcrumbItem="Edit Carousel Banner" />

          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form 
                        className=""
                        method="post"
                        id="tooltipForm">
                          <div>
                            <Row className="mb-3">
                                <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">Name</Label>
                                <div className="col-md-10">
                                <input
                                    className="form-control"
                                    defaultValue={props?.location?.state?.page}
                                    type="text"
                                    id="name_input"
                                />
                                </div>
                            </Row>
                            
                          <Row>
                              {/* <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Section</Label>
                              <Select
                                isSearchable={true}
                                // value={props?.location?.state?.sort_order}
                                // onChange={(e) => {
                                //   handlePaymentInput(e)
                                // }}
                                defaultValue={""}
                                placeholder={navigateObj?.section ? navigateObj?.section : "Choose..."}
                                // defaultValue={paymentOptionGroup.length > 0 && paymentOptionGroup[0].label}
                                // options={paymentOptionGroup}
                                required
                              />
                            </div>
                              </Col>
                            <Col lg={1}></Col> */}
                            <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Section</Label>
                              <Select
                                isSearchable={false}
                                value={selectedSection}
                                onChange={(e) => {
                                  setselectedSection(e)
                                }}
                                placeholder={selectedSection ? selectedSection.label : "Choose section..."}
                                defaultValue={sections[0]}
                                options={sections}
                                required
                              />
                            </div>
                              </Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <Select
                                isSearchable={true}
                                placeholder={props?.location?.state?.sort_order ? props?.location?.state?.sort_order : "Choose..."}
                                options={sortOptions}
                                value={selectedPosition}
                                onChange={(e) => {
                                  setselectedPosition(e)
                                }}
                                defaultValue={props?.location?.state?.sort_order}
                                required
                              />
                            </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                                <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">Navigate To</Label>
                                <div className="col-md-10">
                                <input
                                    className="form-control"
                                    // value={props?.location?.state?.navigate_to}
                                    type="text"
                                    defaultValue={props?.location?.state?.navigate_to}
                                    id="navigate_input"
                                />
                                </div>
                         </Row>                          
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
              <CardBody>
                  {imageURL &&
                    <Row>
                      <Col lg={8}>
                      <CardImg className="img-fluid" src={imageURL}
                        style={{ marginBottom: 15}}
                        alt="" />
                      </Col>
                      <Col>
                      <div className="px-3 text-danger"
                      onClick={()=>{
                        setImageUrl("")
                      }}
                      ><FaRegTrashAlt /></div>
                      </Col>
                  </Row>}
                  <Form>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload"/>
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                            <p style={{fontSize: 12, color: "red"}}>Image should be 1200x500px,  jpg or png</p>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Form>

                  {/* <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Send Files
                    </button>
                  </div> */}
                </CardBody>
              </Card>
              <Card>
                  <CardBody>
                  <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id="publishAt_input"
                                  defaultValue={ props?.location?.state?.published_at ? moment(props?.location?.state?.published_at).format("YYYY/MM/DD HH:mm") : ""}
                                />
                            </div>
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id="unpublishAt_input"
                                  disabled={neverEnding}
                                  defaultValue={props?.location?.state?.unpublished_at ? moment(props?.location?.state?.unpublished_at).format("YYYY/MM/DD HH:mm") : ""}
                                />
                            </div>
                            </div>
                            </Col>
                            <Col style={{paddingTop: 35}}>
                                <div className="form-check form-switch">
                                    <input
                                        type="checkbox"
                                        className="form-check-input checkbox"
                                        id="checkbox_1"
                                        value={neverEnding}
                                        defaultChecked={neverEnding}
                                        onChange={()=>{setNeverEnding(!neverEnding)}}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_1">
                                        Never-ending
                                    </label>
                                </div>
                            </Col>
                          </Row>
                  </CardBody>
              </Card>
              <Card>
                  <CardBody>
                  <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                defaultValue={props?.location?.state?.item_status ? props?.location?.state?.item_status : statusOptions[0].value}
                                value={selectedStatus}
                                placeholder={props?.location?.state?.item_status == "Y" ? "Enabled" : "Disabled" || selectedStatus == "Y" ? "Enabled" : "Disabled"}
                                onChange={(e) => {
                                  setselectedStatus(e)
                                }}
                                options={statusOptions}
                                required
                              />
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="version_input"
                                  defaultValue={props?.location?.state?.item_version}
                              />
                            </div>
                            </div>
                            </Col>
                          </Row>
                  </CardBody>
              </Card>
              {success_msg ? (
                            renderSuccessAlert()
                          ) 
                          :
                          null 
                          }
                          {errorMsgAlert ? (
                            renderFailureAlert()
                          )
                          :
                          null
                          }
              <Row>
                  <Col></Col>
                  <Col>
                  <div className="d-print-none mt-4">
                        <div className="float-end" style={{marginBottom: 20}}>
                        <Link to="#" className="btn btn-light"> <div className="px-3 text-danger"><FaRegTrashAlt /></div></Link>
                        <Link to="#" className="btn btn-danger"> <i className="uil uil-times me-1"></i> Cancel </Link>{" "}
                          <div onClick={()=>{
                            handleSubmit()
                          }} className="btn btn-success w-md waves-effect waves-light">Save</div>
                        </div>
                </div>
                  </Col>
                  <Col lg={3}></Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditCarouselBanner;
